import React from "react";
import localeText from "../../../../locale";
import ConversionList from "./components/ConversionList";
import ExtraPayCard from "./components/ExtrapayCard";
import "./styles.css";

const ExtraPay = () => {
  return (
    <div className="card border-1 border-300">
      <h3 className="my-4">{localeText("extrapayArea")}</h3>
      <hr />
      <div className="extrapay-container">
        <ConversionList />
        <ExtraPayCard />
      </div>
    </div>
  );
};

export default ExtraPay;
